import dayjs from "dayjs";

const columns = [
  {
    title: "Data",
    dataIndex: "created_at",
    sortable: true,
    searchable: false,
    render: (_, { created_at }) => dayjs(created_at).format("DD-MM-YYYY HH:mm"),
  },
  {
    title: "IP",
    dataIndex: "ip",
    sortable: false,
    searchable: true,
    search_method: "matches",
  },
  {
    title: "Typ urządzenia",
    dataIndex: "device_type",
    sortable: false,
    searchable: true,
    search_method: "matches",
    render: (_, { device_type }) => device_type || "-",
  },
  {
    title: "System",
    dataIndex: "os",
    sortable: false,
    searchable: true,
    search_method: "matches",
    render: (_, { os }) => os || "-",
  },
  {
    title: "Miasto",
    dataIndex: "city",
    sortable: false,
    searchable: true,
    search_method: "matches",
    render: (_, { city }) => city || "-",
  },
  {
    title: "Kraj",
    dataIndex: "country",
    sortable: false,
    searchable: true,
    search_method: "matches",
    render: (_, { country }) => country || "-",
  },
];

export default columns;
